/*
 *
 *  NOTICE OF LICENSE
 *
 *  This source file is subject to the Academic Free License (AFL 3.0)
 *
 *   @author    Afternet <info@afternet.gr>
 *   @copyright 2022 Afternet
 *   @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *
 */

import React, {useEffect} from 'react';
import {ReactComponent as Globe} from '../assets/img/icons/globe.svg';
import {ReactComponent as ArrowDown} from '../assets/img/icons/arrowDown.svg';
import useLang from "../Hooks/useLang";
import {useParams} from "react-router-dom";

function LanguageSelect() {

    const params = useParams();
    const [lang, changeLanguage] = useLang();

    const handleTrans = (e, code) => {
        e.preventDefault();
        if( params.lang === code ){ return; }

        changeLanguage(code);
    };

    return (
        <div className='language-select'>
            <div className='language-select__header'>
                <div className='language-select__icon language-select__icon--globe d-none d-md-block'><Globe/></div>
                <div className='language-select__selected'>{lang.currentLang}</div>
                <div className='language-select__icon language-select__icon--arrow'><ArrowDown/></div>
            </div>
            <div className='language-select__body'>
                <ul>
                    { Array.isArray(lang.switchLanguages) && lang.switchLanguages.map((lng, i) => {
                        const { code, native } = lng;
                        return <li key={i}><a href='#' onClick={(e) => handleTrans(e, code)}>{native}</a></li>;
                    })}
                </ul>
            </div>
        </div>
    );
}

export default LanguageSelect;